module.exports = __webpack_public_path__ + "static/img/22hrSlow.c1fff20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/22hrSlow.png
// module id = DCu4
// module chunks = 1